import videojs from "video.js";
const Component = videojs.getComponent('Component');

export class nextVideo extends Component {
	createEl() {
		return videojs.dom.createEl('div', {
			className: 'vjs-next-video-bar'
		});
	}
}

export const initNextVideoBar = (player, section) => {
	
	const video = section.querySelector( '.video' );

	if ( video ) {
		let interval;
		const nextId = video.dataset.nextvideoId;
		const nextAlias = video.dataset.nextvideoAlias;
		
		const initTimer = () => {
			let count = 10;
			const counter = player.getChild('nextVideo').el_.querySelector('span.time-count');
			counter.innerHTML = count;
			interval = setInterval(() => {
				counter.innerHTML = count;
				count--;
				if ( count == -1 ) {
					clearInterval(interval);
	
					const video = section.querySelector('.video');
					const nextId = video.dataset.nextvideoId;
					const nextAlias = video.dataset.nextvideoAlias;
	
					location.href = `/video/${nextAlias}/${nextId}/`;
				}
			}, 1000)
		}
	
		if ( section.querySelector('.video').hasAttribute('data-nextvideo-desc') ) {
			player.addChild('nextVideo', {text: 'Next Video'});
			player.el_.querySelector('.vjs-next-video-bar').innerHTML = `
				<a href="/video/${nextAlias}/${nextId}/">
					<span class="title">Смотрите далее</span>
					<p>${section.querySelector('.video').getAttribute('data-nextvideo-desc')}</p>
					<span class="time-count">10</span>
				</a>
			`;
		}
	
		player.on("timeupdate", function() {
			if ( player.getChild('nextVideo') ) {
				if ( player.cache_.duration !== 0 && player.cache_.currentTime == player.cache_.duration ) {
					player.getChild('nextVideo').el_.classList.add( 'active' );
					if ( !video.classList.contains( 'advertising' ) ) {
						return initTimer();
					}
				} else 
				{
					player.getChild('nextVideo').el_.classList.remove( 'active' );
				}
			}
		});
	
		player.on("playing", function() {
			clearInterval(interval);
		})
	}
}